import './layout.styles.scss'

import Icon from 'components/core-v2/atoms/Icon'
import LinkIcon from 'components/core-v2/molecules/linkIcon'
import TradesApprovalInfoModal from 'components/core-v2/organisms/trades-approval-info-modal'
import { useState } from 'react'

import { FullWidthBar, MasterDetail, Section, Typography } from '../../components/core-v2'
import { TablePaginationParams } from '../../components/core-v2/molecules/table-pagination'
import { UserDisplayInfo } from '../../types/user'
import { TradeSearchFilter } from '../draft-trades/state/draft-trades-slice'
import { TradingAccount } from '../draft-trades/types'
import TradeDetailsPanel from './trade-details-panel'
import { TradesPanel } from './trades-panel'

const Header = ({ setShowLearnMore }: { setShowLearnMore: (showing: boolean) => void }) => (
  <FullWidthBar shouldSpaceBetween>
    <Typography fontSize="15px" fontWeight="700" variant="b3">
      Trade builder
    </Typography>
    <LinkIcon
      icon={<Icon name="circleInfo" size="small" />}
      iconPosition="left"
      text="Learn more about the approval process"
      onClick={() => setShowLearnMore(true)}
    />
  </FullWidthBar>
)

export type TradesLayoutProps = {
  accounts: TradingAccount[]
  filter: TradeSearchFilter
  isLoading: boolean
  onDelete: (accountId: string) => void
  onFilterChange: (updatedFilter: TradeSearchFilter) => void
  onPaginationChange: (updatedPagination: TablePaginationParams) => void
  onStatusChange: (accountId: string) => void
  paginationParams: TablePaginationParams
  totalNumAccounts: number
  userInfo: UserDisplayInfo
}

const TradesLayout = ({
  accounts,
  filter,
  isLoading,
  onDelete,
  onFilterChange,
  onPaginationChange,
  onStatusChange,
  paginationParams,
  totalNumAccounts,
  userInfo
}: TradesLayoutProps) => {
  const [showLearnMore, setShowLearnMore] = useState<boolean>(false)

  return (
    <>
      <Header setShowLearnMore={setShowLearnMore} />
      <MasterDetail
        detailChildren={
          <Section type="quaternary">
            <TradeDetailsPanel
              userInfo={userInfo}
              onDelete={onDelete}
              onStatusChange={onStatusChange}
            />
          </Section>
        }
        masterChildren={
          <Section type="primary">
            <TradesPanel
              accounts={accounts}
              isLoading={isLoading}
              paginationParams={paginationParams}
              searchFilter={filter}
              totalNumAccounts={totalNumAccounts}
              userInfo={userInfo}
              onPaginationChange={onPaginationChange}
              onSearch={onFilterChange}
            />
          </Section>
        }
        width="normal"
      />
      {showLearnMore && <TradesApprovalInfoModal onClose={() => setShowLearnMore(false)} />}
    </>
  )
}

export default TradesLayout
